import styled from 'styled-components'

function BaseAddBoxIcon({ className, size = 24, ...rest }: IconComponentProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4z"
        fill="currentColor"
      />
    </svg>
  )
}

export const AddBoxIcon = styled(BaseAddBoxIcon)``
